export enum SpecialCampaignRequestFieldsSortEnum {
  None,
  Name,
  Status,
  RadarGrowthSpeedIndex,
  RadarGrossFullRevenueForecast1Y,
  RadarStage,
  CountryCode,
  CreatedOn,
}
